import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import { type GetDeviceTypesRequest } from '@service-initiation/shared-clients-tech-care-services';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';
import { type DeviceType } from './types/DeviceType';
import { ubifDeviceTypesToTechCareDeviceTypes } from './utils/ubifDeviceTypesToTechCareDeviceTypes';

export const getDeviceTypes = async (
  request?: GetDeviceTypesRequest
): Promise<DeviceType[]> => {
  try {
    const deviceTypes = await queryClient.fetchQuery({
      queryFn: async () => {
        const response = await techCareServicesClient.getDeviceTypes({
          includeExtended: true,
          includeFull: true,
          includeRepairs: true,
          ...request,
        });

        if (response.status !== HttpStatusCodes.OK) {
          throw new Error('Received invalid response status from server.');
        }

        if (!response.body?.data || !Array.isArray(response?.body?.data)) {
          throw new Error('Failed to fetch device types, received 0 devices.');
        }

        return response.body.data;
      },
      queryKey: ['deviceTypes', request],
      retry: 2,
      staleTime: Infinity,
    });

    return ubifDeviceTypesToTechCareDeviceTypes(deviceTypes);
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to fetch device types.';
    logger.error(err, {
      data: request,
    });
    throw err;
  }
};
